export function getEnv() {
  const host = window.location.hostname;

  if (host === 'localhost' || host === '127.0.0.1') return 'local';
  if (host.includes('digiworks')) return 'preprod';
  if (host.includes('offres-delices') || host.includes('offres.')) return 'prod';

  return 'prod';
}
